import axiosClient from './axiosService';

const BASE_URL = '/otp';

export const requestOtp = (email) =>
    axiosClient.post(`${BASE_URL}/request-otp`, { email });

export const verifyOtpAndResetPassword = (email, otp, newPassword) =>
    axiosClient.post(`${BASE_URL}/verify-otp`, {
        email,
        otp,
        newPassword,
    });
